import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router";
import { useTenantApartments } from "@/api/tenant/queries";
import { LanguageSwitcher } from "@/components/language-switcher";
import { Logo } from "@/components/logo";
import { ClaimApartmentForm } from "@/components/tenant/claim-apartment-form";
import { Button } from "@/components/ui/button";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { isValidLang, ROUTE_SLUGS } from "@/config/routes";
import { useAuth } from "@/contexts/auth-context";

export function ActivateApartmentPage() {
	const { t } = useTranslation();
	const { logout, user } = useAuth();
	const { lang } = useParams<{ lang: string }>();
	const currentLang = lang && isValidLang(lang) ? lang : "pl";
	const { data, isLoading } = useTenantApartments();

	if (isLoading) {
		return (
			<div className="flex min-h-svh items-center justify-center p-4">
				<Skeleton className="h-64 w-full max-w-sm" />
			</div>
		);
	}

	if (data && data.length > 0) {
		return (
			<Navigate
				to={`/${currentLang}/${ROUTE_SLUGS.myApartments[currentLang]}`}
				replace
			/>
		);
	}

	return (
		<div className="relative flex min-h-svh w-full flex-col items-center justify-center gap-6 p-6 md:p-10">
			<div className="absolute top-4 right-4">
				<LanguageSwitcher variant="dark" />
			</div>
			<Logo
				src={user?.logo || undefined}
				className={user?.logo ? "h-12 max-w-[180px]" : undefined}
			/>
			<Card className="w-full max-w-sm">
				<CardHeader>
					<CardTitle>{t("tenant.activate.title")}</CardTitle>
					<CardDescription>{t("tenant.activate.subtitle")}</CardDescription>
				</CardHeader>
				<CardContent className="flex flex-col gap-4">
					<ClaimApartmentForm />
					<Button
						variant="ghost"
						type="button"
						onClick={logout}
						className="self-center"
					>
						{t("tenant.activate.logout")}
					</Button>
				</CardContent>
			</Card>
		</div>
	);
}
